var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityPt1 = function SvgActivityPt1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M1 8.69h2.489a1.3 1.3 0 0 0 1.26-.98c.356-1.396.986-3.86 1.154-4.454a.344.344 0 0 1 .667.01l2.448 10.469c.097.34.54.357.661.027l1.54-4.292c.17-.47.592-.78 1.063-.78H15"
  })));
};
export { SvgActivityPt1 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBzdHJva2U9ImN1cnJlbnRDb2xvciIgZD0iTTEgOC42OWgyLjQ4OWExLjMgMS4zIDAgMCAwIDEuMjYtLjk4Yy4zNTYtMS4zOTYuOTg2LTMuODYgMS4xNTQtNC40NTRhLjM0NC4zNDQgMCAwIDEgLjY2Ny4wMWwyLjQ0OCAxMC40NjljLjA5Ny4zNC41NC4zNTcuNjYxLjAyN2wxLjU0LTQuMjkyYy4xNy0uNDcuNTkyLS43OCAxLjA2My0uNzhIMTUiLz48L3N2Zz4K";